import React from 'react';
import { ITEMS } from './roles';

/*::
type Props = {
  render: string,
  items: Array<any>
}
*/

const Items = ({ render, items, className } /*: Props */) => (
  <div className={`ContentGroup-items ${className}`}>{items.map(render)}</div>
);

Items.role = ITEMS;

export default Items;
